import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import AppContext from './data/AppContext';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: "#ffffff", // White for primary elements (logo text, highlights)
      contrastText: "#000000"
    },
    secondary: {
      main: "#222222", // Deep dark gray for secondary elements
      contrastText: "#ffffff"
    },
    background: {
      default: "#111111", // Almost black background
      paper: "#181818" // Slightly lighter for cards, surfaces
    },
    text: {
      primary: "#ffffff", // White text
      secondary: "#cccccc" // Light gray for secondary text
    },
    info: {
      main: "#ffffff"
    }
  },
  typography: {
    fontFamily: "Roboto, 'Segoe UI', Arial, sans-serif",
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 800,
    h6: {
      color: "#ffffff",
      fontWeight: 700
    },
    body1: {
      color: "#ffffff"
    },
    body2: {
      color: "#cccccc"
    },
    subtitle1: {
      color: "#cccccc"
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <AppContext>
      <App />
    </AppContext>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
